import {
    FETCHED_TAGS,
    FETCHED_TAG,
    CREATED_TAG,
    UPDATED_TAG,
    DELETED_TAG,
    FETCHED_VOCABULARIES,
    FETCHED_VOCABULARY_LEVELS,
    FETCHED_TAG_PARENTS,
    SELECTED_VOCABULARY_ID,
    SELECTED_LEVEL,
    SELECTED_PARENT_TAG,
    SELECTED_TAG_NAME,
    SELECTED_TAGOS_ID,
    CLEAR_FORM_FIELDS,
    FETCHED_TAG_TRANSLATIONS,
    FETCHED_TAG_TRANSLATION,
    DELETED_TAG_TRANSLATION,
    EDIT_TEXT_FIELD_INLINE,
    ADD_TEXT_FIELD_INLINE,
    GET_TRANSLATION_FOR_SITE
} from './types';
import update from 'immutability-helper';
import _sortBy from 'lodash/sortBy';

const INITIAL_STATE = {
    all: [],
    tag: {},
    tagName: '',
    newTranslated: {
        site_id: null,
        display_name: ''
    },
    vocabularyId: null,
    level: null,
    vocabularies: [],
    vocabularyLevels: [],
    tagParents: [],
    tagTranslations: [],
    tagTranslation: {},
    touched: false,
};

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {

        case FETCHED_TAGS:

            return update(state, {
                all: {$set: action.payload.data},
            });

        case FETCHED_TAG:

            return update(state, {
                tag: {$set: action.tag},
                tagName: {$set: action.tag.display_name},
            });

        case CLEAR_FORM_FIELDS:

            return update(state, {
                tag: {$set: {}},
                vocabularyLevels: {$set: []},
                tagParents: {$set: []},
                touched: {$set: false}
            });

        case CREATED_TAG:

            return update(state, {
                tag: {$set: {} }
            });

        case UPDATED_TAG:

            return update(state, {
                tag: {$set: action.tag},
                tagName: {$set: action.tag.display_name},
            });

        case DELETED_TAG:

            let allTags = state.all.filter(item => item.id !== action.tag);

            return update(state, {
                all: {$set: allTags}
            });
        
        case FETCHED_VOCABULARIES:

            return update(state, {
                vocabularies: {$set: action.vocabularies},
            });

        case FETCHED_VOCABULARY_LEVELS:

            return update(state, {
                vocabularyLevels: {$set: action.vocabularyLevels},
            });

        case FETCHED_TAG_PARENTS:

            let sortedTagParents = _sortBy(action.tagParents, 'display_name');

            return update(state, {
                tagParents: {$set: sortedTagParents},
            });

        case SELECTED_VOCABULARY_ID:

            return update(state, {
                tagParents: {$set: []},
                tag: {
                    $merge: {
                        vocabulary_id: action.vocabularyId,
                        level: undefined,
                        parent_id: undefined,
                        display_name: '',
                        tagos_id: undefined,
                    },
                },
                touched: {$set: false}
            });

        case SELECTED_LEVEL:

            return update(state, {
                tag: {
                    $merge: {
                        level: action.level,
                        parent_id: undefined,
                        display_name: '',
                        tagos_id: undefined,
                    },
                },
                touched: {$set: false}
            });
            
        case SELECTED_PARENT_TAG:

            return update(state, {
                tag: {
                    $merge: {parent_id: action.parentTagId},
                },
                touched: {$set: true}
            });
            
        case SELECTED_TAG_NAME:

            return update(state, {
                tag: {
                    $merge: {display_name: action.tagName},
                },
                touched: {$set: true}
            });
            
        case SELECTED_TAGOS_ID:

            return update(state, {
                tag: {
                    $merge: {tagos_id: action.tagTagosId},
                },
                touched: {$set: true}
            });

        case FETCHED_TAG_TRANSLATIONS:

            return update(state, {
                tagTranslations: {$set: action.tagTranslations},
            });

        case FETCHED_TAG_TRANSLATION:

            return update(state, {
                tagTranslation: {$set: action.tagTranslation},
            });

        case GET_TRANSLATION_FOR_SITE:

            let translationForSite = state.tagTranslations.length > 0 
                ? state.tagTranslations.filter(translation => translation.site_id === action.siteId) 
                : [state.newTranslated];

            translationForSite = translationForSite.length > 0
                ? translationForSite
                : [{site_id: action.siteId, display_name: ''}];

            return update(state, {
                tagTranslation: {$set: translationForSite[0]},
                newTranslated: {$set: {
                    site_id: action.siteId,
                    display_name: ''
                }}
            });

        case EDIT_TEXT_FIELD_INLINE:

            return update(state, {
                tagTranslation: {$merge: {
                    display_name: action.translatedName,
                }},
                newTranslated: {$merge: {
                    display_name: action.translatedName,
                }},
            });

        case ADD_TEXT_FIELD_INLINE:

            return update(state, {
                tagTranslation: {$set: {
                    site_id: action.siteId,
                    display_name: action.translatedName,
                }},
                newTranslated: {$set: {
                    site_id: action.siteId,
                    display_name: action.translatedName,
                }},
            });

        case DELETED_TAG_TRANSLATION:

            let allTagTranslations = state.tagTranslations.filter(item => item.id !== action.tagTranslation);

            return update(state, {
                tagTranslations: {$set: allTagTranslations}
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/tags/reducer.js